import React, {useState } from "react";
import { Role } from "../Auth/BackOfficeUserRole";
import Can from "../Auth/Can";
import LinkToOverlay from "../Elements/Overlay/LinkToOverlay";
import {
  deliveryReportFile,
  downloadDocRefFile,
  deleteDocumentIdsFromDocRef,
  getFilteredDocRef,
  removeDeliveryEventsWithReason,
  migrateDeliveryEvents,
} from "../services";
import PomModal from "../Elements/PomModal";

  const ShowDataResponse = ({ data }) => {
    return(<div>
          {Object.entries(data).map(([key, values]) => (
              <div key={key}>
                <h3 className="font-weight-bold  mb-2">{key}</h3>
                {Array.isArray(values) && values.length > 0 ? (
                    <ul>
                      {values.map((item, index) => (
                          <li className="list-unstyled" key={index}>{item}</li>
                      ))}
                    </ul>
                ) : (
                    <ul>
                      <li className="list-unstyled" key={'noItem_'+key}>no items</li>
                    </ul>
                )}
              </div>
          ))}
        </div>);
  };

const usePomModal = ({
  taskId,
  service,
  title,
  confirmMessage,
  submitButton,
  showFeedback,
  inputType = "text",
  placeholder,
  textareaRows = 5,
})=> {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState("");

  const open = () => setIsOpen(true);
  const close = () => {
    setIsOpen(false);
    setValue("");
  };

  const onConfirm = () => service(taskId, value).then((data) => {
    return <ShowDataResponse data={data}/>;
  });

  const actions =[{action:submitButton,showFeedback: showFeedback, displayName:submitButton }];
  const modal = () =>
    isOpen ? (
      <PomModal
        showFeedback={showFeedback}
        submitButton={submitButton}
        onConfirm={onConfirm}
        onAction={onConfirm}
        confirmMessage={confirmMessage}
        isOpen={isOpen}
        onClose={close}
        title={title}
        actions={actions}
        hideSubmit={true}
      >
        {inputType === "text" ? (
          <input
            type="text"
            className="form-control my-2"
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            required
          />
        ) : (
          <textarea
            className="form-control my-2"
            rows={textareaRows}
            placeholder={placeholder}
            value={value}
            onChange={(e) => {
              const normalized = e.target.value
                .split(/\r?\n|\r/)
                .map((s) => s.trim())
                .filter(Boolean)
                .join(",\n");
              setValue(normalized);
            }}
          />
        )}
      </PomModal>
    ) : null;

  return { open, modal };
};

const DocRefBatchActions = ({ taskId }) => {
  const overlayUrl = `/not-reported-document-ids/${taskId}`;

  const downloadDocRefFileFunction = () => {
    return downloadDocRefFile(taskId);
  };

  const deliveryReportFileFunction = () => {
    return deliveryReportFile(taskId);
  };

  const deleteDeliveryEventsWithReasonModal = usePomModal({
    taskId,
    service: removeDeliveryEventsWithReason,
    title: "Reason Deletion",
    confirmMessage: "Please give a reason",
    submitButton: "Delete",
    showFeedback: false,
    inputType: "text",
    placeholder: "Enter reason",
  });

  const deleteDocumentIdsFromDocRefModal = usePomModal({
    taskId,
    service: deleteDocumentIdsFromDocRef,
    title: "Delete Document Ids",
    confirmMessage: "Paste documentIds to delete from document",
    submitButton: "Delete",
    showFeedback: true,
    inputType: "area",
    placeholder: "Paste documentIds",
  });

  const keepDocumentIdsDownNewDocRefModal = usePomModal({
    taskId,
    service: getFilteredDocRef,
    title: "Keep Document Ids",
    confirmMessage: "Paste documentIds to keep from document",
    submitButton: "Download",
    showFeedback: false,
    inputType: "area",
    placeholder: "Paste documentIds",
  });

  const migrateDeliveryEventsModal = usePomModal({
    taskId,
    service: migrateDeliveryEvents,
    title: "Migrate Delivery Events to new batch",
    submitButton: "Migrate",
    showFeedback: false,
    inputType: "text",
    placeholder: "newBatchId",
  });

  return (
    <div className="col mt-5">
      <div className="d-flex flex-column gap-2">
        <a
          className="btn btn-success btn-sm mt-2"
          target="_blank"
          rel="noopener noreferrer"
          href={downloadDocRefFileFunction(taskId)}
        >
          Download docRef file
        </a>
        <Can roles={[Role.READ]}>
          <LinkToOverlay overlay={overlayUrl} overrideClassName="btn btn-success btn-sm mt-2">
            <div>
              See document IDs not reported
            </div>
          </LinkToOverlay>
        </Can>

        <a
          className="btn btn-success btn-sm mt-2"
          target="_blank"
          rel="noopener noreferrer"
          href={deliveryReportFileFunction(taskId)}
        >
          Download delivery report
        </a>
        <Can roles={[Role.WRITE]}>
            <button
              onClick={deleteDeliveryEventsWithReasonModal.open}
              className="btn btn-success btn-sm mt-2"
            >
              Delete delivery events
            </button>
            {deleteDeliveryEventsWithReasonModal.modal()}

            <button
              onClick={deleteDocumentIdsFromDocRefModal.open}
              className="btn btn-success btn-sm mt-2"
            >
              Delete document IDs
            </button>
            {deleteDocumentIdsFromDocRefModal.modal()}
            <button
              onClick={keepDocumentIdsDownNewDocRefModal.open}
              className="btn btn-success btn-sm mt-2"
            >
              Download docRef with document IDs
            </button>
            {keepDocumentIdsDownNewDocRefModal.modal()}
            <button
                onClick={migrateDeliveryEventsModal.open}
                className="btn btn-success btn-sm mt-2"
            >
              Move Delivery Events
            </button>
            {migrateDeliveryEventsModal.modal()}
        </Can>
      </div>

    </div>
  );
};
export default DocRefBatchActions;
